import React from 'react';
import { SvgProps, Svg } from '../../Svg';

const Icon: React.FC<SvgProps> = props => {
  return (
    <Svg
      width="56"
      height="56"
      viewBox="0 0 56 56"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <circle cx="28" cy="28" r="28" fill="#D8D8D8" fillOpacity="0.2" />
      <circle cx="28" cy="28" r="27.5" stroke="#D8D8D8" strokeOpacity="0.2" />
      <path
        d="M34.5443 23.0328L31.857 22.9409L31.2744 37.7712L33.9617 37.8627L34.5443 23.0328Z"
        fill="#DF692B"
      />
      <rect
        x="26.6572"
        y="22.9868"
        width="2.68905"
        height="14.8303"
        fill="#DF692B"
      />
      <path
        d="M24.7279 37.7707L24.1453 22.9404L21.458 23.0324L22.0407 37.8626L24.7279 37.7707Z"
        fill="#DF692B"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 19.3107V16.8042H44V19.3107H41.1527L38.9297 42.8562C38.8693 43.5033 38.2875 44 37.5906 44H18.3641C17.6672 44 17.0859 43.5037 17.0249 42.8566L14.802 19.3107H12ZM19.5968 41.4935H36.3605L38.4549 19.3107H17.5029L19.5968 41.4935Z"
        fill="#DF692B"
      />
      <path
        d="M32.3934 12H23.609C22.3734 12 21.3682 12.937 21.3682 14.0888V18.0574H24.0572V14.5065H31.9452V18.0574H34.6343V14.0888C34.6343 12.937 33.629 12 32.3934 12Z"
        fill="#DF692B"
      />
    </Svg>
  );
};

export default Icon;
